import { createContext } from 'react';

import { OperationMode } from '../../types';

export interface OperationFormContentContextProps {
  brokerTimezoneOffset: number;
  operationId?: string;
  createdAt?: Date;
  mode: OperationMode;
  canChangeClientAndOrder: boolean;
}

export const OperationFormContentContext =
  createContext<OperationFormContentContextProps | null>(null);
